<template>
  <div class="section">
    <div v-if="openMarketInfo.msBsType === 'MS'">
      <div class="section-header">
        <h3>수신자부담 전화안내</h3>
      </div>
      <div class="section-body">
        <dl class="field-group">
          <dt class="field-label">
            수신자부담 전화안내
          </dt>
          <dd class="field-control">
            <ul class="notice-text-list">
              <li class="notice-text">
                유선사업자 수신부담전화를 사전에 차단하기를 희망하는 경우는
                고객이 직접 유선전화 사업자 전국대표번호 1644-1733번으로
                신청하시면 됩니다.
              </li>
              <li class="notice-text">
                SK텔레콤(1541) 수신자부담전화를 차단하시고자 희망하시는 고객은
                직접 1566-0011로 신청하시면 됩니다.
              </li>
            </ul>
          </dd>
        </dl>
      </div>
    </div>

    <div v-if="openMarketInfo.msBsType === 'BS'">
      <div class="section-header">
        <h3>LTE 플러스 약정 할인</h3>
      </div>
      <div class="section-body">
        <dl class="field-group">
          <dt class="field-label">
            LTE 플러스 약정 할인
          </dt>
          <dd class="field-control">
            <ul class="notice-text-list">
              <li class="notice-text">
                요금할인은 LTE플러스 약정할인 프로그램 유지기간(최대 24개월)에만
                제공.
              </li>
              <li class="notice-text">
                스마트 요금제가 아닌 타요금제로 변경 시 LTE플러스 약정할인
                프로그램이 자동 종료됨.
              </li>
            </ul>
            <div class="form-control-sub">
              <a
                @click="openDialog"
                title="새창열림"
                target="_blank"
                class="link-detail"
                >상세보기</a
              >
              <Dialog />
            </div>
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LtePlusSectionView',

  props: {
    openMarketInfoProps: Object
  },

  data() {
    return {
      openMarketInfo: {}
    }
  },

  mounted() {
    this.openMarketInfo = this.openMarketInfoProps
  },

  methods: {
    /** 
     * Function    : openDialog
     * Description : LTE 플러스 약정 할인 상세보기
     **/
    openDialog(e) {
      e.preventDefault()
      window.open(
        'https://www.lguplus.com/benefit-uplus/price-discount/B400000001',
        'PopupWin',
        'width=1100,height=700,top=0,left=0,scrollbars=yes,resizable=yes'
      )
    }
  }
}
</script>

<style scoped></style>
